/* eslint-disable import/no-cycle */
/* eslint-disable import/first */
import React, { useContext } from 'react';
import { useNavigate, useLocation } from '@reach/router';
import Button from '@material-ui/core/Button';
import compact from 'lodash/compact';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
import { FormattedMessage, useIntl } from 'react-intl';
import OrderModeBanner from '../../components/OrderModeBanner';
import Header from '../../components/Header';
import OrderModesBar from '../../components/OrderModesBar';
import LanguageButton from '../../components/LanguageButton';
// import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
// eslint:fix FaArrowLeft is defined but is never used
import { IoMdClose } from '@react-icons/all-files/io/IoMdClose';
import { Badge } from '../../components/Icons';
const { selectAllMain } = Slices.categorySlice;
import { Context } from '../../components/Multi-lang/Wrapper';
import { ChangeLocationConfirm } from '../../components/SavedAddress';
// import css from './index.module.scss';
import css from '../Pickup/index.module.scss';
import {
  storeSelectionAttemptGA,
  storeSelectionFailureGA,
  storeSelectionSuccessGA,
} from 'spwa-ui-library/esm/utils/helperGA';
const { selectLoginStatus } = Slices.authSlice;
import StoreBox from '../../components/StoreBox';
import SelectStore from '../../components/SelectStore';
import SetLoader from '../Carhop/SetLoader';
import OrderModesHeadingDesktop from '../../components/OrderModesHeadingDesktop';
const { useSelector, useDispatch } = Redux;

const { selectDesktop } = Slices.appSlice;
const { selectOrderModeBanner } = Slices.homeSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { getNearStore, selectStoreEntities } = Slices.storeSlice;
const { selectFirstMenu } = Slices.menuSlice;
const {
  postAddressPickup,
  choseStore,
  selectDefaultAddress,
  validateLocation,
} = Slices.addressSlice;
const { sendCart, cartItems, clearCart } = Slices.cartSlice;
const {
  selectBaseURL,
  selectCountryValidations,
  selectOrderModesByCountry,
  selectOrderModeIdx,
} = Slices.configSlice;

export const URLEncode = (inputSrc) => encodeURI(inputSrc?.toLowerCase().replace(/\s/g, '-'));

const searchStore = 'driveThru';

function DriveThru({ closePopUp, loginQR }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const isDesktop = useSelector(selectDesktop);
  const categories = useSelector(selectAllMain);
  const [exploreLink, setExploreLink] = React.useState(null);
  const context = useContext(Context);
  const { action = '' } = location.state || {};
  const intl = useIntl();
  const city = useSelector((state) => state.city);
  // const config = useSelector((state) => state.config);
  // eslint:fix config is defined but is never used
  const cart = useSelector(cartItems);
  const store = useSelector((state) => state.store);
  const profile = useSelector((state) => state.profile);
  // const address = useSelector(selectAddressRootState);
  // eslint:fix address is defined but is never used
  const defaultAddress = useSelector(selectDefaultAddress);
  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const orderModes = useSelector((state) => selectOrderModesByCountry(state, country));
  const imgBaseUrl = useSelector(selectBaseURL);
  const carHopeWidget = useSelector((state) =>
    selectOrderModeBanner(state, 'DRIVE_THRU_BANNER_GROUP')
  );
  const PageSelectedMode = useSelector((state) => selectOrderModeIdx(state, country, 'DRIVETHRU'));
  const user = useSelector(selectLoginStatus);
  const [status, setStatus] = React.useState('initial');
  const [selectedValue, setSelectedValue] = React.useState(0);
  const [selectedStore, setSelectedStore] = React.useState([]);
  const [storeList, setStoreList] = React.useState([]);
  const [carInstruction] = React.useState('');
  const [errorState, setError] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const offer = useSelector((state) => state.offer);
  const couponCode = offer.apply ? offer.apply.couponCode : '';
  const [storeValue, setStoreValue] = React.useState(0);
  const [errorMsg, setErrorMsg] = React.useState('');
  const [selectedCity, setSelectedCity] = React.useState(null);
  const [selectedStoreObj, setSelectedStoreObj] = React.useState(null);
  const [openStore, setOpenStore] = React.useState(false);
  const [pageLoad, setPageLoad] = React.useState(false);
  const storeEntites = useSelector(selectStoreEntities);
  const [storeSelection, setStoreSelection] = React.useState(null);
  // const blobURL = useSelector(getHomeJsonComponents);
  // eslint:fix config is defined but is never used
  const menu = useSelector(selectFirstMenu);
  const firstMenu = useSelector(selectFirstMenu);
  const [cartDropPopup, setCartDropPopup] = React.useState(false);
  const successPosition = (position) => {
    const lat = position.coords.latitude;
    const lng = position.coords.longitude;
    const payload = {
      lat: lat,
      lng: lng,
    };

    dispatch(getNearStore(payload)).then((resp) => {
      setPageLoad(false);
      const storeDetail = resp.payload.data.data;
      if (storeDetail.storeId === 0) {
        alert(intl.formatMessage({ id: 'alert_no_store_available' }));
        setStoreSelection(storeDetail);
      } else {
        setStoreSelection(storeDetail);
      }
    });
  };
  React.useEffect(() => {
    if (storeSelection !== null && storeSelection.cityId) {
      const country_id = city?.ids[0];
      const firstStore = city.entities[country_id];
      const selectedCity = city?.entities[storeSelection.cityId + '_' + firstStore?.countryId];
      const selectedStore2 = selectedCity?.store;
      setSelectedCity({
        title: (selectedCity && selectedCity['name_' + intl.locale]) || '',
        id: storeSelection.cityId + '_' + firstStore?.countryId || null,
      });
      if (storeSelection.storeId === 0) {
        setSelectedStore(selectedStore2);
      } else {
        let storeValue;
        Object.values(storeEntites || {}).every((val) => {
          if (val.storeId === storeSelection.storeId) {
            storeValue = val;
            return false;
          }
          return true;
        });

        if (!storeValue?.services?.[searchStore]) {
          alert(intl.formatMessage({ id: 'alert_no_store_available' }));
          setStoreSelection(null);
        } else {
          setSelectedStore(selectedStore2);
          setStoreValue(storeValue.storeId);
          setSelectedStoreObj({
            title: storeValue['name_' + intl.locale],
            id: storeValue?.id,
          });
        }
      }
    }
  }, [
    city.entities,
    city.ids,
    intl.locale,
    selectedStore,
    storeEntites,
    storeList,
    storeSelection,
  ]);

  const deniedPosition = (error) => {
    setPageLoad(false);
    alert(intl.formatMessage({ id: 'location_denied' }));
  };
  const getCurrentLocation = () => {
    setPageLoad(true);
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => successPosition(pos),
        (err) => deniedPosition(err)
      );
    } else {
      alert(intl.formatMessage({ id: 'alert_browser_support' }));
    }
  };

  const goToCheckout = () => {
    setPageLoad(true);
    setLoader((prev) => true);
    const addressPayload = {
      addressSubType: 'DRIVETHRU',
      addressType: 'DRIVETHRU',
      addressVia: 'DEFAULT',
      areaId: store.entities[storeValue].areaId,
      storeId: store.entities[storeValue].storeId,
    };
    dispatch(choseStore({ city: selectedValue, store: storeValue, instruction: carInstruction }));
    dispatch(postAddressPickup(addressPayload))
      .then((addRespons) => {
        if (addRespons.meta.requestStatus !== 'rejected') {
          window.localStorage.setItem(
            'selectedAddress',
            JSON.stringify(addRespons?.payload?.data?.data)
          );
          window.localStorage.setItem('_add', JSON.stringify(addRespons?.payload?.data?.data));
          storeSelectionSuccessGA(user, loginQR, store.entities[storeValue], defaultAddress);
          if (action === 'select') {
            navigate(-1, { replace: true });
          } else {
            if (isDesktop) {
              if (location?.search?.indexOf('bundleGroup') > -1) {
                navigate(-1, { replace: true });
              } else if (location.pathname.includes('bundle')) {
                navigate(`/${intl.locale}/home`, { replace: true });
              } else {
                navigate(location.pathname, { replace: true });
              }
            } else {
              navigate(`/${intl.locale}/home`, { replace: true });
            }
          }
        } else {
          setPageLoad(false);
          setLoader((prev) => false);
          setError((prev) => true);
          setErrorMsg((old) => addRespons.error.message);
          storeSelectionFailureGA(user, loginQR, store.entities[storeValue]);
        }
      })
      .catch((error) => {
        storeSelectionFailureGA(user, loginQR, store.entities[storeValue]);
        console.log(error);
        setPageLoad(false);
      });
    storeSelectionAttemptGA(user, loginQR, store.entities[storeValue]);
  };
  const StoreName = 'name_' + intl.locale;
  const onStoreLocationChange = () => {
    var selectedStore = store?.entities[storeValue];
    var tempID;
    var menuID;
    let payload = {
      screen: 'HOME',
      addressSubType: 'DRIVETHRU',
      storeId: selectedStore?.storeId,
      areaId: selectedStore.areaId,
      lat: selectedStore?.location?.latitude,
      lng: selectedStore?.location?.latitude,
    };
    setPageLoad(true);
    if (cart.length) {
      dispatch(validateLocation(payload)).then((resp) => {
        setPageLoad(false);
        if (!resp.error) {
          tempID = resp?.payload?.data?.data?.menuTempId || tempID;
          menuID = resp?.payload?.data?.data?.menuId || menuID;
          if (tempID !== firstMenu.menuTemplateId || menuID !== firstMenu.menuId) {
            setCartDropPopup(true);
          } else {
            goToCheckout();
          }
        } else {
          // debugger;
          if (
            selectedStore.menuId !== firstMenu.menuId ||
            selectedStore.menuTempId !== firstMenu.menuTemplateId
          ) {
            setCartDropPopup(true);
          } else {
            goToCheckout();
          }
          setError((prev) => true);
          setErrorMsg((old) => resp.error.message);
        }
      });
    } else {
      goToCheckout();
    }
  };
  const handleStore = (event, selection) => {
    event !== null ? setOpenStore(true) : setOpenStore(false);

    try {
      if (selection?.id !== 0) {
        setSelectedValue(selection?.id);
        if (city?.entities[selection?.id]?.store) {
          setSelectedStore(city?.entities[selection?.id]?.store);
          setSelectedCity({
            title: city?.entities[selection?.id][StoreName],
            id: city?.entities[selection?.id]?.id,
          });
          setSelectedStoreObj(null);
          setStoreValue(0);
        } else {
          setSelectedStore((_prev) => []);
        }
      } else {
        setOpenStore(false);
        setSelectedStore([]);
        setSelectedCity((prev) => 0);
        setSelectedValue((prev) => 0);
      }
      if (selection === null) {
        setOpenStore(false);
        setSelectedStore((prev) => []);
        setSelectedCity((prev) => 0);
        setSelectedValue((prev) => 0);
        setSelectedStoreObj((prev) => []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const selectStore = (_event, selection) => {
    setOpenStore(!openStore);
    if (selection === null) {
      setOpenStore(true);
      setStoreValue((prev) => 0);
      setSelectedStoreObj((prev) => null);
    } else if (selection?.id === 0) {
      setStatus('loaded');
    } else {
      setStatus('selected');
    }
    if (selection && selection !== null) {
      setStoreValue(selection?.id || 0);
      setSelectedStoreObj({
        title: store.entities[selection?.id][StoreName],
        id: store.entities[selection.id]?.id,
      });
    }
  };

  // const handleOnChange = (e) => {
  //   setCarInstruction(e.target.value);
  // };
  // eslint:fix handleOnChange is defined a value but is never used

  let citiesData = [];
  (() => {
    let tempData = city?.entities;
    const cityName = intl.locale === 'en' ? 'cityName' : 'cityNameAr';
    Object.values(tempData).map((City) => {
      const storeKeyList = City.store?.filter((key) => {
        return storeEntites[key]?.services?.driveThru;
      });
      if (storeKeyList.length) citiesData.push({ title: City[cityName], id: City.id });
    });
  })();

  React.useEffect(() => {
    if (categories) {
      const result = categories.sort((a, b) => a.position - b.position);
      const exploreMenuPath = `/${context.locale}/${URLEncode(result[0]?.name)}/${result[0]?.id}`;
      setExploreLink(exploreMenuPath);
    }
  }, [categories, context.locale]);

  React.useEffect(() => {
    const newStore = selectedStore?.map((value) => {
      if (store.entities[value]?.services?.driveThru === 1) {
        return { id: value, title: store.entities[value][StoreName] };
      } else {
        return null;
      }
    });

    if (newStore) setStoreList(compact(newStore));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStore]);

  React.useEffect(() => {
    setTimeout(() => setError(false), 5000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorState]);
  // const onExitMemoized = React.useCallback((e) => navigate('/home'), [navigate]);
  // eslint:fix onExitMemoized is defined but is never used
  const Icon = orderModes.find((val) => val.type === 'DRIVETHRU')?.imageAlt;
  React.useEffect(() => {
    const selectedOrderMode = orderModes.filter((mode) => mode.type == 'DRIVETHRU');
    if (
      (orderModes.length && PageSelectedMode === -1) ||
      selectedOrderMode.length == 0 ||
      !selectedOrderMode[0]?.enable
    ) {
      navigate(`/${intl.locale}/home`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PageSelectedMode]);
  const proceedFetchMenu = () => {
    window.localStorage.setItem('menuUpdate', 'true');
    goToCheckout();
    setCartDropPopup(false);
  };
  return (
    <div className={css.root}>
      {pageLoad && <SetLoader />}
      {!isDesktop && (
        <Header
          title={<FormattedMessage id="selectlocation" defaultMessage="Select Location" />}
          secondaryBar={<OrderModesBar action={action} defaultModeIdx={PageSelectedMode} />}
          actionButtons={[<LanguageButton />]}
        />
      )}
      <OrderModesHeadingDesktop
        heading={
          <FormattedMessage
            id="header_drivethru_heading"
            defaultMessage=" Select Drive-Thru Location"
          />
        }
        closePopUp={closePopUp}
      />

      <main className={css.main}>
        <OrderModeBanner widgetData={carHopeWidget} imgBaseUrl={imgBaseUrl} />
        <div className={css.section}>
          {errorState && (
            <>
              <div className={css.error}>{errorMsg}</div>
            </>
          )}
          <div className={css.storeSection}>
            <div className={css.cityStoreSelector}>
              <div className={css.heading}>
                <h1>
                  <FormattedMessage
                    id="drivethru_outlet"
                    defaultMessage="Choose your KFC drive-thru outlet below"
                  />
                  :
                </h1>
              </div>
              <SelectStore
                setOpenStore={setOpenStore}
                mode="drivethru"
                citiesData={citiesData}
                selectedCity={selectedCity}
                setSelectedCity={setSelectedCity}
                handleStore={handleStore}
                openStore={openStore}
                storeList={storeList}
                selectedStoreObj={selectedStoreObj}
                selectStore={selectStore}
                setSelectedStore={setSelectedStore}
                setStoreSelection={setStoreSelection}
                getCurrentLocation={getCurrentLocation}
              />
            </div>
            {storeValue && selectedStoreObj ? (
              <>
                <h2>
                  <FormattedMessage
                    id="drivethru_selectoutlet"
                    defaultMessage="Selected KFC Outlet"
                  />
                  :
                </h2>
                <StoreBox id={storeValue} mode="drivethru" />
              </>
            ) : (
              ''
            )}
          </div>
        </div>
        <div className={css.addButton}>
          <Button
            variant="contained"
            color="primary"
            onClick={onStoreLocationChange}
            disabled={storeValue === 0 || loader}
          >
            <FormattedMessage id="carhop_proceed" defaultMessage="Proceed" />
          </Button>
        </div>
      </main>
      <footer className={css.footer}></footer>
      {cartDropPopup && (
        <ChangeLocationConfirm
          isOpen={cartDropPopup}
          onCancel={() => {
            setCartDropPopup(false);
          }}
          onConfirm={() => {
            proceedFetchMenu();
          }}
        />
      )}
    </div>
  );
}

export default DriveThru;
